// Initialize the selected section variable
var selected_section = "faq-section-1";

// Define the dictionary mapping section IDs to their corresponding content IDs
var dict = {
  "faq-section-1": "faq-order-and-shipping",
  "faq-section-2": "faq-technical",
  "faq-section-3": "faq-software",
  "faq-section-4": "faq-configuration",
  "faq-section-5": "faq-misc", 
  "faq-section-6": "faq-all"
};

// Wait for the DOM to be ready
document.addEventListener("DOMContentLoaded", function () {
  // Get all elements with class "faq-section"
  var faqSections = document.querySelectorAll(".faq-section");

  // Add a click event listener to each "faq-section" element
  faqSections.forEach(function (section) {
    section.addEventListener("click", function () {
      // If a selected section exists, remove its "faq-selected" class and hide its content
      if (selected_section !== "") {
        document.getElementById(selected_section).classList.remove("faq-selected");
        document.getElementById(dict[selected_section]).classList.add("invisible");
      }

      // Update the selected section and show its content
      selected_section = this.id;
      document.getElementById(dict[selected_section]).classList.remove("invisible");
      this.classList.add("faq-selected");
    });
  });
});

